import { PublicKey } from '@solana/web3.js';
import { RaffleMetaData } from '../lib/types';
import { TESTING } from './misc';

const testWhitelist = new Map<string, RaffleMetaData>([

]);

const prodWhitelist = new Map<string, RaffleMetaData>([
  [
    '3AuxMXuMZyVG5p4uA9mrTs1r31YbP4KFktEUE41jmu47',
    {
      name: 'Kings Of Da Street WL PT:1',
      overviewImageUri: '/resources/WL.png',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    'DtJvSDepkMhCBYnaaonqQccPPeWH9Pnrd4sqRCYgeyGT',
    {
      name: 'Kings Of Da Street WL PT:2',
      overviewImageUri: '/resources/WL.png',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    'Hxs4mmkozhopneusZpZ8VWcjDS2GMD9dGs62xxqfQxBT',
    {
      name: 'Communi3: Mad Scientist',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    'CRUWeBKfRosrXyx9UZ2LJPpWGKaCiEfYWRfUUpA7rwsC',
    {
      name: 'Great Goats WL x7',
      overviewImageUri: '/resources/great_goats.png',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    '3ZUsB777vSJw4tVo4CFvXwKVJZvE7LSW9YWcr27B3Joa',
    {
      name: 'Primates WL x25',
      overviewImageUri: '/resources/primateswl.png',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    'A7sD7YM1CyxEiS9TAsyxBN12QWU2d422vmKrBpPmgPiP',
    {
      name: 'Midnight Panthers WL x10',
      overviewImageUri: 'https://twitter.com/MidnightPanthrs/status/1524454406179241995/photo/1',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    'Bg53pRqo6G4r5Nc4Er4eBxc1TAWVunUYdvFWaWqPak2Y',
    {
      name: 'Zillaz 1/1',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    'F4SepTi9b1mfEz6L916LQSnCLBZwVwagiuabbUgXyGWP',
    {
      name: 'Zillaz 1/1 + Rare',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ],
  [
    '7UocQBuFoGbxdRV51ArAx6tkDCVuwbMyULeuk4HN9NfK',
    {
      name: 'Primates #1925',
      alternatePurchaseMints: [
        new PublicKey('B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi'),
      ]
    },
  ]
]);

export const RAFFLES_WHITELIST = TESTING
  ? testWhitelist
  : prodWhitelist;